// extracted by mini-css-extract-plugin
export var introSectionStyle = "home-module--intro-section-style--1st3y";
export var nameStyle = "home-module--name-style--1d6vG";
export var profilePictureStyle = "home-module--profile-picture-style--hboUW";
export var sectionTitleStyle = "home-module--section-title-style--2Ho1b";
export var sectionContentStyle = "home-module--section-content-style--Jn_Rc";
export var contentListStyle = "home-module--content-list-style--u5uC1";
export var publicationListStyle = "home-module--publication-list-style--2Jh0G";
export var importantNameStyle = "home-module--important-name-style--34gJv";
export var publicationLinkStyle = "home-module--publication-link-style--Bcvo9";